import type { FC } from 'react';

import cn from 'classnames';

interface MemberListRowSkeletonProps {
  className?: string;
}

/** Loading placeholder matching the MemberListRow layout (avatar + name + headline). */
export const MemberListRowSkeleton: FC<MemberListRowSkeletonProps> = ({ className }) => (
  <div className={cn('relative flex items-center gap-4 py-2 animate-pulse', className)}>
    <div className="size-10 md:size-14 shrink-0 rounded-full bg-black/10" />
    <div className="flex flex-col gap-2 min-w-0 flex-1">
      <div className="h-4 w-32 rounded bg-black/10" />
      <div className="h-3 w-48 rounded bg-black/5" />
    </div>
  </div>
);

/** Initial-load placeholder for member-list feeds: 3 rows on mobile, 5 on desktop. */
export const MemberListSkeleton: FC = () => (
  <div className="flex flex-col gap-2" aria-busy="true">
    <MemberListRowSkeleton />
    <MemberListRowSkeleton />
    <MemberListRowSkeleton />
    <div className="hidden md:contents">
      <MemberListRowSkeleton />
      <MemberListRowSkeleton />
    </div>
  </div>
);
